// extracted by css-extract-rspack-plugin
export default {"pricingItem":"pricingItem-DAS0aL text-xl-semibold","highlighted":"highlighted-AyIKp3","itemLabel":"itemLabel-nm3tPl","itemValue":"itemValue-pghcDm","box":"box-xP3nuG"};